/** @format */

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  jobStatusState: "",
  jobMultiStatusState: [],
  jobIdState: "",
  fromDateState: "",
  toDateState: "",
  isArdoState: false,
  isAdditionalPayment: false,
  departmentIdState: "",
  masterProcessIdState: "",
  processIdState: "",
  cspNameState: "",
  referenceName: "",
  clearFilterFlag: 0,
  departmentList: [],
  masterProcessList: [],
  processList: [],
};

const JobFilterSlice = createSlice({
  name: "jobFilter",
  initialState,
  reducers: {
    getJobStatus(state, action) {
      state.jobStatusState = action.payload;
    },
    getJobMultiStatusState(state, action) {
      state.jobMultiStatusState = action.payload;
    },
    getJobId(state, action) {
      state.jobIdState = action.payload;
    },
    getFromDate(state, action) {
      state.fromDateState = action.payload;
    },
    getToDate(state, action) {
      state.toDateState = action.payload;
    },
    getIsArdo(state, action) {
      state.isArdoState = action.payload;
    },
    getIsAdditionalPayment(state, action) {
      state.isAdditionalPayment = action.payload;
    },
    getDepartmentId(state, action) {
      state.departmentIdState = action.payload;
    },
    getMasterProcessId(state, action) {
      state.masterProcessIdState = action.payload;
    },
    getProcessId(state, action) {
      state.processIdState = action.payload;
    },
    getCspName(state, action) {
      state.cspNameState = action.payload;
    },
    getClearFilterFlag(state, action) {
      state.clearFilterFlag = action.payload;
    },
    getDepartmentList(state, action) {
      state.departmentList = action.payload;
    },
    getMasterProcessList(state, action) {
      state.masterProcessList = action.payload;
    },
    getProcessList(state, action) {
      state.processList = action.payload;
    },
    getReferenceName(state, action) {
      state.referenceName = action.payload;
    },
    reset(state) {
      state.jobStatusState = "";
      state.jobMultiStatusState = [];
      state.jobIdState = "";
      state.fromDateState = "";
      state.toDateState = "";
      state.isArdoState = false;
      state.isAdditionalPayment = false;
      state.departmentIdState = "";
      state.masterProcessIdState = "";
      state.processIdState = "";
      state.cspNameState = "";
      state.referenceName = "";
      state.clearFilterFlag = 0;
      state.masterProcessList = [];
      state.processList = [];
    },
  },
});

export const {
  getJobStatus,
  getJobMultiStatusState,
  getProcessId,
  getCspName,
  getJobId,
  getFromDate,
  getToDate,
  getDepartmentList,
  getMasterProcessList,
  getProcessList,
  getIsArdo,
  getDepartmentId,
  getMasterProcessId,
  getClearFilterFlag,
  getReferenceName,
  reset,
  getIsAdditionalPayment,
} = JobFilterSlice.actions;

export default JobFilterSlice.reducer;
